import * as PIXI from 'pixi.js'
import { VideoController } from '@/pixi/types'

const addVideoController = (texture: PIXI.Texture, controllers: VideoController[]): void => {
  const videoResource = texture.baseTexture.resource instanceof PIXI.VideoResource ? texture.baseTexture.resource : undefined
  if (videoResource && !controllers.find(x => x.video === videoResource.source)) {
    controllers.push({
      texture: texture,
      video: videoResource.source,
      seekPromise: Promise.resolve(),
      currentTimeSeconds: 0
    })
  }
}

const registerVideosInDisplayObject = (displayObject: PIXI.DisplayObject, controllers: VideoController[]): void => {
  if (displayObject instanceof PIXI.Container) {
    displayObject.children.forEach(childDisplayObject => registerVideosInDisplayObject(childDisplayObject, controllers))
  }
  if (displayObject.isSprite) {
    const sprite = displayObject as PIXI.Sprite
    addVideoController(sprite.texture, controllers)
  }
  if (displayObject.filters !== null) {
    displayObject.filters.forEach(filter => {
      Object.entries(filter.uniformGroup.uniforms).forEach(([key, value]) => {
        if (value instanceof PIXI.Texture) {
          const effectTexture = filter.uniformGroup.uniforms[key]
          addVideoController(effectTexture, controllers)
        }
      })
    })
  }

}
export default function getPixiVideoControllers (pixiApplication: PIXI.Application): VideoController[] {
  const videoControllers: VideoController[] = []
  pixiApplication.stage.children.forEach(layer => {
    registerVideosInDisplayObject(layer, videoControllers)
  })
  return videoControllers
}